define(
	'actions/email-activities',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addEmailActivities: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.INIT_EMAIL_ACTIVITIES,
					data: params
				});
			},
			updateEmailActivity: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.REFRESH_EMAIL_ACTIVITY,
					data: params
				});
			},
			initEmailActivity: function(item) {
				return {
					buncee_guid : item.buncee_guid,
					title: item.title,
					thumbnail: item.url,
					representative_recipient: item.recipient,
					total: item.total,
					delivered: item.total_delivered,
					created_at: new Date(item.created_at)
				};
			},
			pull: function() {
				var self = this;
				var emailActivities = [];
				
				window.api.request("emailActivity").each(function iterator (index, item) {
					emailActivities.push(self.initEmailActivity(item));
				}, function () {
					self.addEmailActivities(emailActivities);
				});
			},
			refresh: function(buncee_guid) {
				var self = this;

				window.api.request("emailActivity", buncee_guid, "getOne").execute().done(function(response) {
					self.updateEmailActivity(self.initEmailActivity(response.data));
				});
			}
		});
	}
);
